export enum InjectableInterfaces {
    ICanvasScaler = "ICanvasScaler",
    IPackageRegistrator = "IPackageRegistrator",
    IDataStorage = "IDataStorage",
    VictorySceneOptions = "VictorySceneOptions",
    LoseSceneOptions = "LoseSceneOptions",
    GameSceneOptions = "GameSceneOptions",
    IGameDistributionSdk = "IGameDistributionSdk"
}